import React from 'react';
import remove_duplicates_from_list from '../../../utils/remove_duplicates_from_list';
import { useSelector } from 'react-redux';

export default function Counts() {
  const { selectedImageIds, temporaryImageIds } = useSelector((state) => state.images);

  let temp_ids = temporaryImageIds || [];
  let selected_ids = selectedImageIds || [];

  let list = [...selected_ids, ...temp_ids];
  list = remove_duplicates_from_list(list);
  const list_number = (list && list.length) || 0;

  const showNumberOfImages = () => {
    if (list_number) return `${list_number} ${list_number === 1 ? 'Image' : 'Images'} Selected`;
  };
  return <div style={text}>{showNumberOfImages()}</div>;
}

const text = {
  color: 'white',
  height: '60px',
  background: '#616161',
  minWidth: '245px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
